import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-mini-env-faqs',
  imports: [CommonModule],
  templateUrl: './mini-env-faqs.component.html',
  styleUrl: './mini-env-faqs.component.scss'
})
export class MiniEnvFaqsComponent implements OnChanges {

  @Input() faqData: any[] = [];
  activeIndex: number | null = 0; // Set to 0 to have first one open by default

  /** faqData with {{tenant}} resolved. The template renders this, not the raw input. */
  resolvedFaqs: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['faqData']) {
      this.resolvedFaqs = this.resolveTenant(this.faqData);
    }
  }

  /**
   * Mini-env FAQ copy comes straight from static JSON, so its {{tenant}} tokens never
   * pass through the translate pipe that would normally resolve them. Swap in the
   * tenant's full name from the environment, building new objects so the caller's
   * array — usually a module-level JSON import — is left untouched.
   */
  private resolveTenant(items: any[]): any[] {
    const tenantName = environment.TenantFullName || environment.TENANT;
    return (items || []).map(item => ({
      ...item,
      title: this.replaceTenant(item?.title, tenantName),
      description: this.replaceTenant(item?.description, tenantName)
    }));
  }

  private replaceTenant(value: any, tenantName: string): any {
    return typeof value === 'string' ? value.replaceAll('{{tenant}}', tenantName) : value;
  }

  toggleItem(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
}
